
import React from 'react';

export const WhyChooseUsSection: React.FC = () => {
  const features = [
    {
      icon: 'ri-award-line',
      title: '13+ Years Experience',
      description: 'Over a decade of expertise in creating memorable travel experiences for families and individuals.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Personalized Service',
      description: 'Every itinerary is crafted specifically for you, ensuring your unique preferences are met.'
    },
    {
      icon: 'ri-global-line',
      title: 'Worldwide Destinations',
      description: 'Access to exclusive destinations and experiences across all continents and cultures.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Travel Protection',
      description: 'Comprehensive travel insurance and 24/7 support to ensure peace of mind during your journey.'
    },
    {
      icon: 'ri-group-line',
      title: 'Multi-Generational Focus',
      description: 'Specializing in creating experiences that bring families together across different age groups.'
    },
    {
      icon: 'ri-vip-crown-line',
      title: 'Exclusive Access',
      description: 'Special partnerships with hotels, cruise lines, and tour operators for unique experiences.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Why Choose Prime Meridian Travel?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We go beyond booking trips – we create life-changing experiences that bring people together
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-2xl text-emerald-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
